import React, { FC } from 'react'
import { BadgeProps } from '@mui/material/Badge/Badge'

import { SidebarNotificationBadge } from '../SidebarNotificationBadge'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import { useAllUnreadMessagesCount } from '../../../../../../hooks/contexts/chat/useAllUnreadMessagesCount'

interface SidebarChatMessagesBadgeProps {
	readonly badgeProps?: BadgeProps
}

const SidebarChatMessagesBadge: FC<SidebarChatMessagesBadgeProps> = ({
	badgeProps,
}: SidebarChatMessagesBadgeProps) => {
	const unreadMessagesCount = useAllUnreadMessagesCount()

	return (
		<SidebarNotificationBadge
			badgeContent={unreadMessagesCount}
			color='orange'
			{...badgeProps}
		>
			<ChatBubbleOutlineIcon color={'secondary'} fontSize={'inherit'} />
		</SidebarNotificationBadge>
	)
}

export default SidebarChatMessagesBadge
